export default __webpack_public_path__ + "static/media/Aeonik-Light.33acaec1.ttf";